import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  REFERENCE_DETAIL_FETCH,
  REFERENCE_DETAIL_SUCCESS,
  REFERENCE_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { REFERENCE_FORM_NAME } from '../ReferenceForm/constants';

//<<<---REFERENCE-DETAIL--->>>
export const referenceDetailFetch = createAction(REFERENCE_DETAIL_FETCH);
export const referenceDetailSuccess = createAction(REFERENCE_DETAIL_SUCCESS);
export const referenceDetailFailure = createAction(REFERENCE_DETAIL_FAILURE);

export const fetchReferenceDetail = (id, lang) => async dispatch => {
  dispatch(referenceDetailFetch());
  try {
    const { data } = await api.get(`reference/${id}/${lang}`);

    const { headerImage } = data;

    const fieldNames = ['header', 'headerImage', 'subtitle', 'content'];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(REFERENCE_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(REFERENCE_FORM_NAME, 'headerImage', {
        src: headerImage
      })
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(referenceDetailSuccess());
  } catch (error) {
    dispatch(referenceDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/ReferenceDetail/actions.js